import { render, staticRenderFns } from "./newScriptManagement.vue?vue&type=template&id=38cef7da&scoped=true"
import script from "./newScriptManagement.vue?vue&type=script&lang=js"
export * from "./newScriptManagement.vue?vue&type=script&lang=js"
import style0 from "./newScriptManagement.vue?vue&type=style&index=0&id=38cef7da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cef7da",
  null
  
)

export default component.exports